import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorTransactionFundBillSearch = () => {
  const transactionFundBillSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/fund-bill/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { transactionFundBillSearch }
}

export default InteractorTransactionFundBillSearch
